import { render, staticRenderFns } from "./PlmnTable.vue?vue&type=template&id=ac609f6e&scoped=true&"
import script from "./PlmnTable.vue?vue&type=script&lang=js&"
export * from "./PlmnTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac609f6e",
  null
  
)

export default component.exports